import { StyleRules } from "@material-ui/core";
import { WHITE } from "constants/colors";

export const styles: StyleRules = {
  container: {
    borderRadius: "5px",
    padding: "15px",
  },
  textMessage: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    paddingTop: "20px",
    fontStyle: "normal",
    width: "150px",
    lineHeight: "1.43",
    paddingLeft: "0px !important",
    letterSpacing: "normal",
    color: WHITE,
    margin: "0px",
  },
};
